/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {useAuth0} from '@auth0/auth0-react';
import LogoutIcon from '@mui/icons-material/Logout';
import {ListItemIcon, MenuItem} from '@mui/material';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import {useNavigate} from 'react-router-dom';

import {ROUTES} from '../routes';

interface UserPopoverProps {
  anchorEl: null | Element;
  onClose?: () => void;
  open: boolean;
}

export function UserPopover({anchorEl, onClose, open}: UserPopoverProps) {
  const {user} = useAuth0();
  const navigate = useNavigate();
  const handleLogout = () => {
    navigate(ROUTES.LOGOUT);
  };
  if (!user) return null;
  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
      onClose={onClose}
      open={Boolean(open)}
      slotProps={{paper: {sx: {width: '280px', marginTop: '4px'}}}}
      transformOrigin={{horizontal: 'right', vertical: 'top'}}
    >
      <Box sx={{p: 2, mt: 0.5}}>
        <Typography>{user.name}</Typography>
        {user.username !== user.name && (
          <Typography color={'text.secondary'} variant={'body2'}>
            {user.username}
          </Typography>
        )}
      </Box>
      <Divider />
      <Box sx={{p: 1}}>
        <MenuItem component={'div'} onClick={handleLogout} sx={{justifyContent: 'center', gap: 1}}>
          Sign Out
          <ListItemIcon>
            <LogoutIcon fontSize={'small'} />
          </ListItemIcon>
        </MenuItem>
      </Box>
    </Popover>
  );
}
